module.exports = __webpack_public_path__ + "static/service-banner-phone-3e7f354680212182e7e5217350e2cd04.png";